import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["accept"]
const _hoisted_2 = { class: "description" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Segment = _resolveComponent("Segment")
  const _component_UploadItem = _resolveComponent("UploadItem")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_FileItem = _resolveComponent("FileItem")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Segment, {
      class: _normalizeClass(["uploader-segment", {'active': _ctx.active, 'error': _ctx.error && !_ctx.active}]),
      onDragover: _withModifiers(_ctx.dragover, ["prevent"]),
      onDrop: _withModifiers(_ctx.drop, ["prevent"]),
      onDragleave: _withModifiers(_ctx.dragleave, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          id: "file",
          ref: "file",
          type: "file",
          accept: _ctx.accept,
          style: {"display":"none"},
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.onFileInput())),
          onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1),
        _createElementVNode("div", {
          class: "drop-block pointer",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.$refs.file.click()))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["image", {'error': _ctx.error && !_ctx.active}])
          }, [
            _createVNode(_component_Icon, {
              class: "upload-icon",
              icon: "upload-cloud-02",
              width: "2rem",
              height: "2rem"
            })
          ], 2 /* CLASS */),
          _createElementVNode("div", _hoisted_2, [
            _cache[5] || (_cache[5] = _createElementVNode("div", null, [
              _createElementVNode("span", { class: "click-to" }, "Click to upload"),
              _createTextVNode(" or drag and drop")
            ], -1 /* HOISTED */)),
            _createElementVNode("div", null, _toDisplayString(_ctx.allowed_types_text) + " (max " + _toDisplayString(_ctx.$utils.format.bytes(_ctx.maxSize)) + ")", 1 /* TEXT */)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "onDragover", "onDrop", "onDragleave"]),
    _createCommentVNode(" Uploads list "),
    (_ctx.uploads?.length)
      ? (_openBlock(), _createBlock(_component_Segment, {
          key: 0,
          class: "list"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ScrollBar, {
              ref: "uploads_scroll",
              style: _normalizeStyle({'height': _ctx.uploads_height})
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"display":"grid","gap":"0.1rem"},
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploads, (upload) => {
                    return (_openBlock(), _createBlock(_component_UploadItem, {
                      id: upload.id,
                      key: upload.id,
                      ref_for: true,
                      ref: "uploads",
                      mode: _ctx.mode,
                      instance: upload,
                      class: "item",
                      inline: true,
                      onDelete: $event => (_ctx.store.deleteUpload(upload.id))
                    }, null, 8 /* PROPS */, ["id", "mode", "instance", "onDelete"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])), [
                  [_directive_resize, _ctx.onUploadsResize]
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Files list "),
    (_ctx.files?.length)
      ? (_openBlock(), _createBlock(_component_Segment, {
          key: 1,
          class: "list"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ScrollBar, {
              ref: "files_scroll",
              style: _normalizeStyle({'height': _ctx.files_height})
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "flex-col",
                  style: {"gap":"0.1rem"},
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                    return (_openBlock(), _createBlock(_component_FileItem, {
                      id: file.id,
                      key: file.id,
                      ref_for: true,
                      ref: "files",
                      file: file,
                      class: "item",
                      mode: _ctx.mode,
                      onDelete: $event => (_ctx.onRemove(file.id)),
                      onDownload: $event => (_ctx.onDownload(file.id))
                    }, null, 8 /* PROPS */, ["id", "file", "mode", "onDelete", "onDownload"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])), [
                  [_directive_resize, _ctx.onFilesResize]
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}